module.exports = __webpack_public_path__ + "img/ea72818.jpg";